import Axios from "@/utils/Axios";
import config from "@/config";

export interface ContactUsType {
  phone: string;
  name: string;
  enterprise_name: string;
  staff_size: string;
  industry: string; // 1:5人一下   2: 5-20人   3: 20-50人  4: 50人以上
  deptName: string;
}

export function contactUs(data: ContactUsType) {
  return Axios.post("/ai_creator/contact/create", data, {}, config.gwURL);
}
